import { faCog } from '@fortawesome/free-solid-svg-icons';
import { faSun } from '@fortawesome/free-solid-svg-icons';
import { faMoon } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import './StyleSwitcher.css'

const StyleSwitcher = () => {


    const [defaultTheme, setDefaultTheme] = useState('');

    useEffect(() => {
        document.body.className = defaultTheme;
        setDefaultTheme(sessionStorage.getItem('theme') || 'dark');
    }, [defaultTheme])

    const handleTheme = (theme) => {
        if (theme) {
            sessionStorage.setItem('theme', 'dark')
            setDefaultTheme('dark');
        } else {
            sessionStorage.setItem('theme', ' ')
            setDefaultTheme(' ');
        }
    }
    // const [defaultTheme, setDefaultTheme] = useState(sessionStorage.getItem('theme') || 'dark');

    // const handleTheme = () => {
    //     setDefaultTheme(sessionStorage.getItem('theme'))
    // }

    // document.body.className = defaultTheme;

    // const handleBackgroundChange = (e) => {
    //     if (e.target.value === 'dark') {
    //         sessionStorage.setItem('theme', 'dark')
    //     }
    //     else if (e.target.value === 'navy-blue') {
    //         sessionStorage.setItem('theme', 'navy-blue')
    //     }
    //     else {
    //         sessionStorage.setItem('theme', ' ')
    //     }
    //     handleTheme()
    // }


    const handleStyleSwitcher = () => {
        document.querySelector('.style-switcher').classList.toggle('open');
    }

    const links = document.querySelectorAll('.skin-css');
    const totalLinks = links.length;

    const handleSkinChange = (color) => {

        for (let i = 0; i < totalLinks; i++) {
            if (color === links[i].getAttribute('title')) {
                links[i].removeAttribute('disabled');
            }
            else {
                links[i].setAttribute('disabled', 'true');
            }
        }
    }

    return (
        <>
            <div className="style-switcher">
                <div onClick={handleStyleSwitcher} className="toggle-style-switcher">
                    <FontAwesomeIcon className="fa-spin" icon={faCog} />
                </div>
                <h3>Skin Color</h3>
                <ul>
                    <li><span title="pink" style={{ backgroundColor: '#ec1839' }} onClick={() => handleSkinChange('pink')}></span></li>
                    <li><span title="blue" style={{ backgroundColor: '#2196F3' }} onClick={() => handleSkinChange('blue')}></span></li>
                    <li><span title="orange" style={{ backgroundColor: '#fa5b0f' }} onClick={() => handleSkinChange('orange')}></span></li>
                    <li><span title="yellow" style={{ backgroundColor: '#ffb400' }} onClick={() => handleSkinChange('yellow')}></span></li>
                    <li><span title="green" style={{ backgroundColor: '#72b626' }} onClick={() => handleSkinChange('green')}></span></li>
                </ul>
                {/* <h3>Theme</h3>
            <label>
                <input onClick={handleBackgroundChange} type="radio" name="body-style" value="navy-blue" defaultChecked={defaultTheme === 'navy-blue' && true} />
                Navy blue
            </label>
            <br />
            <label>
                <input onClick={handleBackgroundChange} type="radio" name="body-style" value="dark" defaultChecked={defaultTheme === 'dark' && true} />
                Dark
            </label>
            <br />
            <label>
                <input onClick={handleBackgroundChange} type="radio" name="body-style" value="light" defaultChecked={defaultTheme === ' ' && true} />
                Light
            </label> */}

            </div>
            <div className="mode-switcher">
                <div className="btn-box" title='Theme'>
                    <div id="btn" className={defaultTheme === 'dark' ? 'active' : null}></div>
                    <button className="toggle-btn" onClick={() => handleTheme(false)}><FontAwesomeIcon icon={faSun} /></button>
                    <button className="toggle-btn" onClick={() => handleTheme('dark')}><FontAwesomeIcon icon={faMoon} /></button>
                </div>
            </div>


        </>


    );
};

export default StyleSwitcher;